export enum Countries {
    Egypt = 1,
    Bangladesh = 2,
    Bahrain = 3,
    KSA = 4,
    Kuwait = 5,
    Oman = 6,
    Qatar = 7,
    UAE = 8,
    Lebanon = 9,
    Libya = 10,
    Ethiopia = 11,
    CoteDIvoire = 12,
    Kenya = 13,
    Sudan = 14,
    Uganda = 15,
    Yemen = 16,
    Other = 17,
    Iraq = 19
}
